import { logger } from "logging";


export const getStorageData = (key: string, isLocalStorage: boolean): any => {
  let data : any = "";
  if (isLocalStorage) {
    data = localStorage.getItem(key);
  } else {
    data = sessionStorage.getItem(key);
  }
  if (data) {
    return data;
  }
  return "";
};

export const removeStorage = (key: string, isLocalStorage: boolean): void => {
  try {
    if (isLocalStorage) {
      localStorage.removeItem(key);
    } else {
      sessionStorage.removeItem(key);
    }
  }
  catch (error) {
    logger.error(error, "Error in remove Storage");
  }
};

/**
 * function to store data in local storage and  session storage
 */
export const setStorage = ({
  key,
  data,
  isLocalStorage = false,
}: {
  key: string;
  data: any;
  isLocalStorage?: boolean;
}) => {
  try {
    let value = data;
    if (typeof value !== "string") {
      /**
       * session storage and  local storage only accept strings as values
       */
      value = JSON.stringify(value);
    }
    if (isLocalStorage) {
      localStorage.setItem(key, value);
    } else {
      sessionStorage.setItem(key, value);
    }
  } catch (error) {
    logger.error(error, "Error in set Storage");
  }
};
